<ng-template #solicitareTestADN let-modal="close">
  <div class="modal-header">
    <h3 class="modal-title">Solicitare Test ADN</h3>

    <div class="col-sm-12 col-md-12 col-lg-6 text-right custom-col">
      <div class="btn-group custom-modal-btn">
        <button
          class="btn btn-sm btn-secondary"
          (click)="modal('Cross click')"
          autofocus="false"
        >
          Închide
        </button>
      </div>
    </div>
  </div>

  <div class="modal-body">
    <div class="container-fluid fs-4" [formGroup]="solicitareTestADNForm">
      <table class="list-items-table text-center">
        <tr>
          <th></th>
          <th>Nr. matricol</th>
          <th>Cod crotalie R.G.</th>
          <th>Rasa</th>
          <th>Data Nașterii</th>
          <th>Material biologic</th>
        </tr>

        <tr>
          <th>Animal</th>
          <td>{{ animal.numarmatricol }}</td>
          <td>{{ animal.id_rg }}</td>
          <td>{{ animal.rasa_scurt }}</td>
          <td>{{ animal.data_nastere_dmy }}</td>
          <td>
            <ng-select formControlName="animal_material_biologic">
              <ng-option
                *ngIf="animal.material_biologic"
                [value]="animal.material_biologic"
                >{{ animal.material_biologic }}</ng-option
              >
              <ng-option value="țesut auricular">țesut auricular</ng-option>
              <ng-option value="sânge">sânge</ng-option>
              <ng-option value="fire de păr">fire de păr</ng-option>
            </ng-select>
          </td>
        </tr>

        <tr>
          <th>Tata</th>
          <td>{{ tata.numarmatricol }}</td>
          <td>{{ tata.id_rg }}</td>
          <td>{{ tata.rasa_scurt }}</td>
          <td>{{ tata.data_nastere_dmy }}</td>
          <td>
            <ng-select formControlName="tata_material_biologic">
              <ng-option
                *ngIf="tata.material_biologic"
                [value]="tata.material_biologic"
                >{{ tata.material_biologic }}</ng-option
              >
              <ng-option value="țesut auricular">țesut auricular</ng-option>
              <ng-option value="sânge">sânge</ng-option>
              <ng-option value="fire de păr">fire de păr</ng-option>
            </ng-select>
          </td>
        </tr>

        <tr>
          <th>Mama</th>
          <td>{{ mama.numarmatricol }}</td>
          <td>{{ mama.id_rg }}</td>
          <td>{{ mama.rasa_scurt }}</td>
          <td>{{ mama.data_nastere_dmy }}</td>
          <td>
            <ng-select formControlName="mama_material_biologic" class="w12">
              <ng-option
                *ngIf="mama.material_biologic"
                [value]="mama.material_biologic"
                >{{ mama.material_biologic }}</ng-option
              >
              <ng-option value="țesut auricular">țesut auricular</ng-option>
              <ng-option value="sânge">sânge</ng-option>
              <ng-option value="fire de păr">fire de păr</ng-option>
            </ng-select>
          </td>
        </tr>
      </table>

      <br />
      <div [formGroup]="solicitareTestADNForm.controls.teste_adn">
        <div>
          <input
            type="checkbox"
            formControlName="profil"
            class="square_1_point_5 mr-2"
            id="profil"
          />
          <label for="profil">Profil</label>
        </div>

        <div>
          <input
            type="checkbox"
            formControlName="verificare_tata"
            class="square_1_point_5 mr-2"
            id="verificare_tata"
          />
          <label for="verificare_tata">Verificare tată</label>
        </div>

        <div>
          <input
            type="checkbox"
            formControlName="verificare_mama"
            class="square_1_point_5 mr-2"
            id="verificare_mama"
          />
          <label for="verificare_mama">Verificare mamă</label>
        </div>

        <div>
          <input
            type="checkbox"
            formControlName="verificare_tata_si_mama"
            class="square_1_point_5 mr-2"
            id="verificare_tata_si_mama"
          />
          <label for="verificare_tata_si_mama">Verificare tată + mamă</label>
        </div>

        <div>
          <input
            type="checkbox"
            formControlName="atribuirea_rasei"
            class="square_1_point_5 mr-2"
            id="atribuirea_rasei"
          />
          <label for="atribuirea_rasei">
            Test pentru atribuirea rasei / purității
          </label>
        </div>

        <div>
          <input
            type="checkbox"
            formControlName="test_genomic"
            class="square_1_point_5 mr-2"
            id="test_genomic"
          />
          <label for="test_genomic">
            Test GEBV. Estimarea valorii de ameliorare genomica la tauri / vaci
          </label>
        </div>

        <div>
          <input
            type="checkbox"
            formControlName="reconstituire_tata"
            class="square_1_point_5 mr-2"
            id="reconstituire_tata"
          />
          <label for="reconstituire_tata">Reconstituire tată</label>
        </div>

        <div>
          <input
            type="checkbox"
            formControlName="reconstituire_mama"
            class="square_1_point_5 mr-2"
            id="reconstituire_mama"
          />
          <label for="reconstituire_mama">Reconstituire mamă</label>
        </div>
      </div>

      <br /><br />
      <button
        *ngIf="isAdmin || isOperator"
        class="btn btn-lg btn-success"
        (click)="onSubmitted()"
      >
        Descarcă
      </button>
    </div>
  </div>
</ng-template>
